import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
import RequestHandler from "../../util/RequestHandler";

const HomePageBankList = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1230px)' });
  const [data, setData] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/TenantAccount?$filter=isCalculated eq true&$skip=0&$top=10`).then(response => {
      setData(response.value);
    });
  }, []);

  return (
    isTabletOrMobile ?
      data.map((item) => {
      
        if (item.bankId === 999) {
          return <Link to={`/bank-accounts-account-transaction/${item.id}`}> <div className="gx-media gx-featured-item" style={{ borderBottom: 'solid 1px #e8e8e8', paddingBottom: 11, marginBottom: 16, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} >
            <div >
              <img style={{ width: 150 }} src={item.bankLogo} alt="paratic" />
            </div>

            <div className="gx-media-body gx-featured-content">
              <div className="gx-featured-content-left">
                <p className="gx-rounded-xs gx-text-uppercase" style={{ color: 'black', fontSize: 12 }}>{item.currency}</p>
                <h3 className="gx-mb-2"></h3>
                <div className="ant-row-flex">
                  <div className="gx-media gx-text-grey gx-mb-1">
                    <i className={`icon icon-datepicker gx-fs-lg gx-mr-2 gx-d-inline-flex gx-vertical-align-middle`} />
                    <span className="gx-media-body gx-ml-1" style={{ fontSize: 12, width: 203 }}>Son sorgulanma: {moment(item.updateDate).format("L")} {moment(item.updateDate).format("LT")}</span>
                  </div>
                </div>
              </div>
              <div className="gx-featured-content-right gx-profile-content-right">
                <h4 className="gx-text-primary gx-mb-1">
                 
                  <span
                    className="gx-d-inline-flex gx-vertical-align-middle" >

                      {
                        props.isDigitHomePage ? 
                        (item.balanceString.includes('-') ? <p style={{ color: "red", fontSize: 11, width: 72 }}>{item.balanceString}</p> :
                        <p style={{ color: "green" }}>{item.balanceString}</p>)
                      :
                      (item.balanceString.includes('-') ? <p style={{ color: "red" }}>{item.balanceString.toString().split(",")[0]}</p> :
                      <p style={{ color: "green", fontSize: 11, width: 72  }}>{item.balanceString.toString().split(",")[0]}</p>)
                      }
                  </span>
                </h4>
              </div>
            </div>
          </div></Link>
        } else {
          return <Link to={`/bank-accounts-account-transaction/${item.id}`}> <div className="gx-media gx-featured-item" style={{ borderBottom: 'solid 1px #e8e8e8', paddingBottom: 11, marginBottom: 16, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <div >
              <img style={{ width: 150 }} src={item.bankLogo} alt="paratic" />
            </div>
            <div className="gx-media-body gx-featured-content">
              <div className="gx-featured-content-left" style={{ color: 'black', fontSize: 12 }}>
                {item.iban === null ? item.accountNumber : item.iban} / {item.currency}
                <h3 className="gx-mb-2"></h3>
                <div className="ant-row-flex">
                  <div className="gx-media gx-text-grey gx-mb-1">
                    <i className={`icon icon-datepicker gx-fs-lg gx-mr-2 gx-d-inline-flex gx-vertical-align-middle`} />
                    <span className="gx-media-body gx-ml-1" style={{ fontSize: 12, width: 203 }}>Son sorgulanma: {moment(item.updateDate).format("L")} {moment(item.updateDate).format("LT")}</span>
                  </div>
                </div>
              </div>
              <div className="gx-featured-content-right gx-profile-content-right">
                <h4 className="gx-text-primary gx-mb-1">
                  <span
                    className="gx-d-inline-flex gx-vertical-align-middle" >
                    {item.balanceString.includes('-') ? <p style={{ color: "red", fontSize: 11, width: 72 }}>{item.balanceString}</p> :
                      <p style={{ color: "green", fontSize: 11, width: 72 }}>{item.balanceString}</p>}
                  </span>
                </h4>
              </div>
            </div>
          </div></Link>
        }

      })
      :
      data.map((item) => {
        if (item.bankId === 999) {
          return <Link to={`/bank-accounts-account-transaction/${item.id}`}> <div className="gx-media gx-featured-item" style={{ borderBottom: 'solid 1px #e8e8e8', paddingBottom: 11, marginBottom: 16, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <div className="gx-featured-thumb">
              <img className="gx-rounded-lg" style={{ width: 110 }} src={item.bankLogo} alt="paratic" />
            </div>
            <div className="gx-media-body gx-featured-content">
              <div className="gx-featured-content-left">
                <p className="gx-rounded-xs gx-text-uppercase">{item.currency}</p>
                <h3 className="gx-mb-2"></h3>
                <div className="ant-row-flex">
                  <div className="gx-media gx-text-grey gx-mb-1">
                    <i className={`icon icon-datepicker gx-fs-lg gx-mr-2 gx-d-inline-flex gx-vertical-align-middle`} />
                    <span className="gx-media-body gx-ml-1">Son sorgulanma: {moment(item.updateDate).format("L")} {moment(item.updateDate).format("LT")}</span>
                  </div>
                </div>
              </div>
              <div className="gx-featured-content-right gx-profile-content-right">
                <h4 className="gx-text-primary gx-mb-1">
                  <span
                    className="gx-d-inline-flex gx-vertical-align-middle" >
                    {
                        props.isDigitHomePage ? 
                        (item.balanceString.includes('-') ? <p style={{ color: "red" }}>{item.balanceString}</p> :
                        <p style={{ color: "green" }}>{item.balanceString}</p>)
                      :
                      (item.balanceString.includes('-') ? <p style={{ color: "red" }}>{item.balanceString.toString().split(",")[0]}</p> :
                      <p style={{ color: "green" }}>{item.balanceString.toString().split(",")[0]}</p>)
                      }
                    
                  </span>
                </h4>
              </div>
            </div>
          </div></Link>
        } else {
          return <Link to={`/bank-accounts-account-transaction/${item.id}`}> <div className="gx-media gx-featured-item" style={{ borderBottom: 'solid 1px #e8e8e8', paddingBottom: 11, marginBottom: 16, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <div className="gx-featured-thumb">
              <img className="gx-rounded-lg" style={{ width: 110 }} src={item.bankLogo} alt="paratic" />
            </div>
            <div className="gx-media-body gx-featured-content">
              <div className="gx-featured-content-left" style={{ color: 'black' }}>
                {item.iban === null ? item.accountNumber : item.iban} / {item.currency}
                <h3 className="gx-mb-2"></h3>
                <div className="ant-row-flex">
                  <div className="gx-media gx-text-grey gx-mb-1">
                    <i className={`icon icon-datepicker gx-fs-lg gx-mr-2 gx-d-inline-flex gx-vertical-align-middle`} />
                    <span className="gx-media-body gx-ml-1">Son sorgulanma: {moment(item.updateDate).format("L")} {moment(item.updateDate).format("LT")}</span>
                  </div>
                </div>
              </div>
              <div className="gx-featured-content-right gx-profile-content-right">
                <h4 className="gx-text-primary gx-mb-1">
                  <span
                    className="gx-d-inline-flex gx-vertical-align-middle" >
                      {
                        props.isDigitHomePage ? 
                        (item.balanceString.includes('-') ? <p style={{ color: "red" }}>{item.balanceString}</p> :
                        <p style={{ color: "green" }}>{item.balanceString}</p>)
                      :
                      (item.balanceString.includes('-') ? <p style={{ color: "red" }}>{item.balanceString.toString().split(",")[0]}</p> :
                      <p style={{ color: "green" }}>{item.balanceString.toString().split(",")[0]}</p>)
                      }
                  </span>
                </h4>
              </div>
            </div>
          </div></Link>
        }

      }))
}
export default HomePageBankList;
